/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { changeRetirementDateGetResponseSchema } from './changeRetirementDateGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getChangeRetirementDate200Schema = z.lazy(() => changeRetirementDateGetResponseSchema);

/**
 * @description 505 response
 */
export const getChangeRetirementDate505Schema = z.any();

export const getChangeRetirementDateQueryResponseSchema = z.lazy(() => getChangeRetirementDate200Schema);
